let currentToken = localStorage.getItem('token') || null;

export const setToken = (token) => {
  currentToken = token;
  if (token) {
    localStorage.setItem('token', token);
  } else {
    localStorage.removeItem('token');
  }
};

export const getToken = () => {
  if (!currentToken) {
    currentToken = localStorage.getItem('token');
  }
  return currentToken;
};
